import CountUp from "react-countup";

const Stats = ({ topStats }) => {
  return (
    <div className="row g-4 mb-4">
      {topStats?.map((item, index) => (
        <div className="col-12 col-sm-6 col-lg-4" key={index}>
          <div className="dashboard-card">
            <div
              className="dashboard-icon"
              style={{ backgroundColor: item.color }}
            >
              {item.icon}
            </div>

            <div>
              <p className="dashboard-label">{item.label}</p>

              <h5>
                {item.isPrice ? "$" : ""}
                <CountUp
                  end={Math.round(Number(item.value))}
                  duration={2}
                  separator=","
                  decimals={0}
                />
              </h5>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default Stats;
